module.exports = __webpack_public_path__ + "static/media/stars.8bca45c2.png";